<template>
  <PageLayout>
    <template #main>
      <PageHeader
        :user-name="userDisplayName"
        welcome-message="Willkommen im Übersichts-Dashboard"

      />
        <!-- hero-image-url="/_assets/v11/902eb6ab9478d66c46eaaa8e0314895eea8a1108.png" -->
      <h1>App Playground</h1>
      <p>This is the main content area of the App Playground.</p>
      ascsc scak nalks ncalskj dsalkdj aslkdjasj lsdlkasj dsascsc scak nalks ncalskj dsalkdj aslkdjasj lsdlkasj dsalkdj lkjdaslk djsalkdj salkdj salkdjsadl kjlkdj lkjdaslk djsalkdj salkdj salkdjsadl kjsadlksaj dlksajd lsakjd asldjsalk jdsadlkj asdlkj asdlkjsa lkjsad lkjasdl ksad lsakjd

      <div class="playground-content p-4">
        <h1 class="mb-4">Bootstrap Theme Testing Playground</h1>

        <!-- Buttons Section -->
        <section class="mb-5">
          <h2 class="mb-3">Buttons</h2>

          <h3 class="mb-3 mt-4">Primary Buttons</h3>
          <div class="d-flex flex-wrap gap-2 mb-3">
            <BButton variant="primary">Primary</BButton>
            <BButton variant="secondary">Secondary</BButton>
            <BButton variant="success">Success</BButton>
            <BButton variant="danger">Danger</BButton>
            <BButton variant="warning">Warning</BButton>
            <BButton variant="info">Info</BButton>
            <BButton variant="light">Light</BButton>
            <BButton variant="dark">Dark</BButton>
            <BButton variant="link">Link</BButton>
          </div>

          <h3 class="mb-3 mt-4">Primary Buttons w/ Icons</h3>
          <div class="d-flex flex-wrap gap-2 mb-3">
            <BButton variant="primary">
              <Download :size="16" class="me-1" />
              Primary
            </BButton>
            <BButton variant="secondary">
              <Save :size="16" class="me-1" />
              Secondary
            </BButton>
            <BButton variant="success">
              <Check :size="16" class="me-1" />
              Success
            </BButton>
            <BButton variant="danger">
              <X :size="16" class="me-1" />
              Danger
            </BButton>
            <BButton variant="warning">
              <AlertTriangle :size="16" class="me-1" />
              Warning
            </BButton>
            <BButton variant="info">
              <Info :size="16" class="me-1" />
              Info
            </BButton>
            <BButton variant="light">
              <Sun :size="16" class="me-1" />
              Light
            </BButton>
            <BButton variant="dark">
              <Moon :size="16" class="me-1" />
              Dark
            </BButton>
            <BButton variant="link">
              <ExternalLink :size="16" class="me-1" />
              Link
            </BButton>
          </div>

          <h3 class="mb-3 mt-4">Outline Buttons</h3>
          <div class="d-flex flex-wrap gap-2 mb-3">
            <BButton variant="outline-primary">Primary</BButton>
            <BButton variant="outline-secondary">Secondary</BButton>
            <BButton variant="outline-success">Success</BButton>
            <BButton variant="outline-danger">Danger</BButton>
            <BButton variant="outline-warning">Warning</BButton>
            <BButton variant="outline-info">Info</BButton>
            <BButton variant="outline-light">Light</BButton>
            <BButton variant="outline-dark">Dark</BButton>
          </div>


          <h3 class="mb-3 mt-4">Outline Buttons w/ Icons</h3>
          <div class="d-flex flex-wrap gap-2 mb-3">
            <BButton variant="outline-primary">
              <Download :size="16" class="me-1" />
              Primary
            </BButton>
            <BButton variant="outline-secondary">
              <Save :size="16" class="me-1" />
              Secondary
            </BButton>
            <BButton variant="outline-success">
              <Check :size="16" class="me-1" />
              Success
            </BButton>
            <BButton variant="outline-danger">
              <X :size="16" class="me-1" />
              Danger
            </BButton>
            <BButton variant="outline-warning">
              <AlertTriangle :size="16" class="me-1" />
              Warning
            </BButton>
            <BButton variant="outline-info">
              <Info :size="16" class="me-1" />
              Info
            </BButton>
            <BButton variant="outline-light">
              <Sun :size="16" class="me-1" />
              Light
            </BButton>
            <BButton variant="outline-dark">
              <Moon :size="16" class="me-1" />
              Dark
            </BButton>
          </div>

          <h3 class="mb-3 mt-4">Button Sizes & States</h3>
          <div class="d-flex flex-wrap gap-2 mb-3 align-items-center">
            <BButton variant="primary" size="lg">Large</BButton>
            <BButton variant="primary">Normal</BButton>
            <BButton variant="primary" size="sm">Small</BButton>
            <BButton variant="primary" disabled>Disabled</BButton>
          </div>

          <h3 class="mb-3 mt-4">Button Sizes & States w/ Icons</h3>
          <div class="d-flex flex-wrap gap-2 mb-3 align-items-center">
            <BButton variant="primary" size="lg"><AlertTriangle :size="16" class="me-1" />Large</BButton>
            <BButton variant="primary"><Info :size="16" class="me-1" />Normal</BButton>
            <BButton variant="primary" size="sm"><Save :size="16" class="me-1" />Small</BButton>
            <BButton variant="primary" disabled><Sun :size="16" class="me-1" />Disabled</BButton>
          </div>

          <h3 class="mb-3 mt-4">Button Groups</h3>
          <div class="mb-3">
            <h4 class="h6 mb-2">Basic Button Group</h4>
            <BButtonGroup>
              <BButton variant="primary">Links</BButton>
              <BButton variant="primary">Mitte</BButton>
              <BButton variant="primary">Rechts</BButton>
            </BButtonGroup>
          </div>

          <div class="mb-3">
            <h4 class="h6 mb-2">Button Toolbar</h4>
            <BButtonToolbar>
              <BButtonGroup class="me-2">
                <BButton variant="secondary">1</BButton>
                <BButton variant="secondary">2</BButton>
                <BButton variant="secondary">3</BButton>
              </BButtonGroup>
              <BButtonGroup class="me-2">
                <BButton variant="secondary">4</BButton>
                <BButton variant="secondary">5</BButton>
              </BButtonGroup>
              <BButtonGroup>
                <BButton variant="secondary">6</BButton>
              </BButtonGroup>
            </BButtonToolbar>
          </div>

          <div class="mb-3">
            <h4 class="h6 mb-2">Vertical Button Group</h4>
            <BButtonGroup vertical>
              <BButton variant="outline-primary">Oben</BButton>
              <BButton variant="outline-primary">Mitte</BButton>
              <BButton variant="outline-primary">Unten</BButton>
            </BButtonGroup>
          </div>

          <div class="mb-3">
            <h4 class="h6 mb-2">Button Group Sizes</h4>
            <div class="d-flex gap-3 align-items-center">
              <BButtonGroup size="lg">
                <BButton variant="success">Groß</BButton>
                <BButton variant="success">Gruppe</BButton>
              </BButtonGroup>
              <BButtonGroup>
                <BButton variant="info">Normal</BButton>
                <BButton variant="info">Gruppe</BButton>
              </BButtonGroup>
              <BButtonGroup size="sm">
                <BButton variant="warning">Klein</BButton>
                <BButton variant="warning">Gruppe</BButton>
              </BButtonGroup>
            </div>
          </div>
                    <div class="mb-3">
            <h4 class="h6 mb-2">Button Group Sizes</h4>
            <div class="d-flex gap-3 align-items-center">
              <BButtonGroup size="lg">
                <BButton variant="success">Groß</BButton>
                <BButton variant="success">Gruppe</BButton>
              </BButtonGroup>
              <BButtonGroup>
                <BButton variant="info">Normal</BButton>
                <BButton variant="info">Gruppe</BButton>
              </BButtonGroup>
              <BButtonGroup size="sm">
                <BButton variant="warning">Klein</BButton>
                <BButton variant="warning">Gruppe</BButton>
              </BButtonGroup>
            </div>
          </div>

          <div class="mb-3">
            <h4 class="h6 mb-2">Button Groups mit Icons</h4>
            <BButtonGroup>
              <BButton variant="outline-secondary">
                <i class="fa fa-align-left"></i>
              </BButton>
              <BButton variant="outline-secondary">
                <i class="fa fa-align-center"></i>
              </BButton>
              <BButton variant="outline-secondary">
                <i class="fa fa-align-right"></i>
              </BButton>
              <BButton variant="outline-secondary">
                <i class="fa fa-align-justify"></i>
              </BButton>
            </BButtonGroup>
          </div>

          <div class="mb-3">
            <h4 class="h6 mb-2">Button Group mit Dropdown</h4>
            <BButtonGroup>
              <BButton variant="primary">Aktion 1</BButton>
              <BButton variant="primary">Aktion 2</BButton>
              <BDropdown variant="primary" right text="Mehr Aktionen">
                <BDropdownItem>Aktion 3</BDropdownItem>
                <BDropdownItem>Aktion 4</BDropdownItem>
                <BDropdownDivider />
                <BDropdownItem>Weitere Option</BDropdownItem>
              </BDropdown>
            </BButtonGroup>
          </div>

          <div class="mb-3">
            <h4 class="h6 mb-2">Split Button mit Dropdown</h4>
            <BButtonGroup>
              <BButton variant="success">Hauptaktion</BButton>
              <BDropdown variant="success" split right>
                <BDropdownItem>Option 1</BDropdownItem>
                <BDropdownItem>Option 2</BDropdownItem>
                <BDropdownItem>Option 3</BDropdownItem>
              </BDropdown>
            </BButtonGroup>
          </div>
        </section>

         <!-- Treeselect Section -->
        <section class="mb-5">
          <h2 class="mb-3">Treeselect (Vue3-Treeselect)</h2>

          <BRow>
            <BCol md="6" class="mb-4">
              <h4 class="h6 mb-2">Single Select (Geschlossen)</h4>
              <Treeselect
                v-model="treeselectSingle"
                :options="treeselectOptions"
                placeholder="Bitte wählen..."
                :searchable="true"
                :clearable="true"
              />
              <p class="mt-2 text-muted">Ausgewählt: {{ treeselectSingle }}</p>
            </BCol>

            <BCol md="6" class="mb-4">
              <h4 class="h6 mb-2">Single Select (Offen)</h4>
              <Treeselect
                v-model="treeselectSingleOpen"
                :options="treeselectOptions"
                placeholder="Bitte wählen..."
                :searchable="true"
                :clearable="true"
                :default-expand-level="Infinity"
                :open-on-focus="true"
              />
              <p class="mt-2 text-muted">Ausgewählt: {{ treeselectSingleOpen }}</p>
            </BCol>

            <BCol md="6" class="mb-4">
              <h4 class="h6 mb-2">Multi Select (Geschlossen)</h4>
              <Treeselect
                v-model="treeselectMulti"
                :multiple="true"
                :options="treeselectOptions"
                placeholder="Mehrfachauswahl möglich..."
                :searchable="true"
                :clearable="true"
              />
              <p class="mt-2 text-muted">Ausgewählt: {{ treeselectMulti }}</p>
            </BCol>

            <BCol md="6" class="mb-4">
              <h4 class="h6 mb-2">Multi Select (Offen/Expanded)</h4>
              <Treeselect
                v-model="treeselectMultiOpen"
                :alwaysOpen="false"
                :multiple="true"
                :options="treeselectOptions"
                placeholder="Mehrfachauswahl möglich..."
                :searchable="true"
                :clearable="true"
                :default-expand-level="Infinity"
              />
              <p class="mt-2 text-muted">Ausgewählt: {{ treeselectMultiOpen }}</p>
            </BCol>

            <BCol md="6" class="mb-4">
              <h4 class="h6 mb-2">Mit Flat Optionen (keine Hierarchie)</h4>
              <Treeselect
                v-model="treeselectFlat"
                :options="treeselectFlatOptions"
                placeholder="Einfache Liste..."
                :searchable="true"
                :clearable="true"
              />
            </BCol>

            <BCol md="6" class="mb-4">
              <h4 class="h6 mb-2">Disabled</h4>
              <Treeselect
                v-model="treeselectDisabled"
                :options="treeselectOptions"
                placeholder="Deaktiviert..."
                :disabled="true"
              />
            </BCol>
          </BRow>
        </section>

        <!-- Form Controls Section -->
        <section class="mb-5">
          <h2 class="mb-3">Form Controls</h2>

          <BRow>
            <BCol md="6">
              <BForm>
                <BFormFloatingLabel label="Text Input" class="mb-3">
                  <BFormInput v-model="testForm.text" placeholder="Geben Sie Text ein" />
                </BFormFloatingLabel>

                <BFormFloatingLabel label="Email" class="mb-3">
                  <BFormInput v-model="testForm.email" type="email" placeholder="email@example.com" autocomplete="email" />
                </BFormFloatingLabel>

                <BFormFloatingLabel label="Password" class="mb-3">
                  <BFormInput v-model="testForm.password" type="password" placeholder="Passwort" autocomplete="current-password" />
                </BFormFloatingLabel>

                <BFormFloatingLabel label="Disabled Input" class="mb-3">
                  <BFormInput value="Disabled" disabled />
                </BFormFloatingLabel>

                <BFormFloatingLabel label="Readonly Input" class="mb-3">
                  <BFormInput value="Readonly" readonly />
                </BFormFloatingLabel>
              </BForm>
            </BCol>

            <BCol md="6">
              <BForm>
                <BFormFloatingLabel label="Select" class="mb-3">
                  <BFormSelect v-model="testForm.select" :options="selectOptions" />
                </BFormFloatingLabel>

                <BFormFloatingLabel label="Textarea" class="mb-3">
                  <BFormTextarea v-model="testForm.textarea" placeholder="Geben Sie Text ein" rows="3" />
                </BFormFloatingLabel>

                <BFormFloatingLabel label="Number" class="mb-3">
                  <BFormInput v-model="testForm.number" type="number" placeholder="0" />
                </BFormFloatingLabel>

                <BFormFloatingLabel label="Date" class="mb-3">
                  <BFormInput v-model="testForm.date" type="date" />
                </BFormFloatingLabel>
              </BForm>
            </BCol>
          </BRow>

          <h3 class="mb-3 mt-4">Checkboxes & Radio Buttons</h3>
          <BRow>
            <BCol md="6">
              <BFormGroup label="Checkboxes">
                <BFormCheckbox v-model="testForm.checkbox1" class="mb-2">Option 1</BFormCheckbox>
                <BFormCheckbox v-model="testForm.checkbox2" class="mb-2">Option 2</BFormCheckbox>
                <BFormCheckbox value="disabled" disabled class="mb-2">Disabled</BFormCheckbox>
              </BFormGroup>
            </BCol>

            <BCol md="6">
              <BFormGroup label="Radio Buttons">
                <BFormRadio v-model="testForm.radio" value="option1" class="mb-2">Option 1</BFormRadio>
                <BFormRadio v-model="testForm.radio" value="option2" class="mb-2">Option 2</BFormRadio>
                <BFormRadio value="disabled" disabled class="mb-2">Disabled</BFormRadio>
              </BFormGroup>
            </BCol>
          </BRow>

          <h3 class="mb-3 mt-4">Switch</h3>
          <BFormCheckbox v-model="testForm.switch" switch class="mb-3">
            Toggle Switch
          </BFormCheckbox>
        </section>

        <!-- Alerts Section -->
        <section class="mb-5">
          <h2 class="mb-3">Alerts</h2>
          <BAlert variant="primary" show class="mb-2">Primary Alert</BAlert>
          <BAlert variant="secondary" show class="mb-2">Secondary Alert</BAlert>
          <BAlert variant="success" show class="mb-2">Success Alert</BAlert>
          <BAlert variant="danger" show class="mb-2">Danger Alert</BAlert>
          <BAlert variant="warning" show class="mb-2">Warning Alert</BAlert>
          <BAlert variant="info" show class="mb-2">Info Alert</BAlert>
          <BAlert variant="light" show class="mb-2">Light Alert</BAlert>
          <BAlert variant="dark" show class="mb-2">Dark Alert</BAlert>

          <h2 class="mb-3 mt-4">Dismissable Alerts mit Template</h2>

          <BAlert variant="primary" show dismissible>
            <template #title>
              <strong>Primary Alert</strong>
            </template>
            Primary Alert-Inhalt mit Titel, dismissable [x] Button.
          </BAlert>
        </section>

        <!-- Badges Section -->
        <section class="mb-5">
          <h2 class="mb-3">Badges</h2>
          <div class="d-flex flex-wrap gap-2">
            <BBadge variant="primary">Primary</BBadge>
            <BBadge variant="secondary">Secondary</BBadge>
            <BBadge variant="success">Success</BBadge>
            <BBadge variant="danger">Danger</BBadge>
            <BBadge variant="warning">Warning</BBadge>
            <BBadge variant="info">Info</BBadge>
            <BBadge variant="light">Light</BBadge>
            <BBadge variant="dark">Dark</BBadge>
          </div>
        </section>

        <!-- Cards Section -->
        <section class="mb-5">
          <h2 class="mb-3">Cards</h2>
          <BRow>
            <BCol md="4" class="mb-3">
              <BCard title="Default Card" sub-title="Card subtitle">
                <BCardText>
                  Dies ist der Card-Inhalt mit normalem Text.
                </BCardText>
                <BButton variant="primary">Action</BButton>
              </BCard>
            </BCol>

            <BCol md="4" class="mb-3">
              <BCard bg-variant="primary" text-variant="white" title="Primary Card">
                <BCardText>
                  Card mit Primary Background.
                </BCardText>
              </BCard>
            </BCol>

            <BCol md="4" class="mb-3">
              <BCard border-variant="danger" title="Border Card">
                <BCardText>
                  Card mit farbigem Border.
                </BCardText>
              </BCard>
            </BCol>
          </BRow>
          <h2 class="mb-3 mt-4">Custom Cards</h2>
          <BRow>
            <BCol md="6" class="mb-3">
              <CustomCard title="Standard Card">
                Card Content hier
              </CustomCard>
            </BCol>
            <BCol md="6" class="mb-3">
              <!-- Mit Varianten -->
              <CustomCard title="Highlighted Card" variant="highlighted">
                Wichtiger Content
              </CustomCard>
            </BCol>
            <BCol md="6" class="mb-3">

              <CustomCard variant="primary" elevated>
                <template #header>
                  <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Custom Header</h5>
                    <BButton size="sm" variant="light">Action</BButton>
                  </div>
                </template>

                Card Body Content

                <template #footer>
                  <div class="d-flex justify-content-end gap-2">
                    <BButton variant="secondary" size="sm">Abbrechen</BButton>
                    <BButton variant="primary" size="sm">Speichern</BButton>
                  </div>
                </template>
              </CustomCard>
            </BCol>
            <BCol md="6" class="mb-3">

              <!-- Minimal ohne Header -->
              <CustomCard variant="minimal">
                Einfacher Content ohne Header
              </CustomCard>
            </BCol>
            <BCol md="12" class="mb-3">
              <CustomCard variant="default" elevated>
                <template #header-title>
                  <Info :size="18" />
                  <span>Dashboard Übersicht</span>
                  <ChevronRight :size="16" />
                </template>

                <template #header-subtitle>
                  Aktuelle Metriken und Berichte
                </template>

                <template #header-actions-top>
                  <BButton variant="outline-secondary" size="sm">
                    <Download :size="16" />
                  </BButton>
                  <BButton variant="outline-secondary" size="sm">
                    <Share2 :size="16" class="me-2" />
                    {{ $t('Webportal.Share') }}
                  </BButton>
                  <BButton variant="primary" size="sm">
                    {{ $t('Webportal.Export') }}
                  </BButton>
                </template>

                <template #header-actions-bottom>
                  <BButton variant="outline-secondary" size="sm">
                    <Save :size="16" class="me-2" />
                    {{ $t('Webportal.SaveView') }}
                  </BButton>
                  <BFormSelect size="sm" style="width: 250px;">
                    <option>{{ $t('Webportal.ChangeView') }}...</option>
                  </BFormSelect>
                </template>

                <!-- Card Body Content -->
                <p>Hier kommt der Hauptinhalt der Card.</p>
              </CustomCard>
            </BCol>
          </BRow>
        </section>

        <!-- Overlay Section -->
        <section class="mb-5">
          <h2 class="mb-3">Overlays</h2>

          <BRow>
            <BCol md="6" class="mb-4">
              <h4 class="h6 mb-2">Basic Overlay</h4>
              <BOverlay :show="overlayShow1" rounded>
                <BCard title="Overlay Card" sub-title="Toggle overlay">
                  <BCardText>
                    Dies ist ein Card-Inhalt, der mit einem Overlay überlagert werden kann.
                  </BCardText>
                  <BButton variant="primary" @click="overlayShow1 = !overlayShow1">
                    Toggle Overlay
                  </BButton>
                </BCard>
              </BOverlay>
            </BCol>

            <BCol md="6" class="mb-4">
              <h4 class="h6 mb-2">Overlay mit Custom Spinner</h4>
              <BOverlay :show="overlayShow2" rounded spinner-variant="primary" spinner-type="grow">
                <BCard title="Loading Card">
                  <BCardText>
                    Custom Spinner (grow) in Primary Farbe.
                  </BCardText>
                  <BButton variant="success" @click="overlayShow2 = !overlayShow2">
                    Toggle Overlay
                  </BButton>
                </BCard>
              </BOverlay>
            </BCol>

            <BCol md="6" class="mb-4">
              <h4 class="h6 mb-2">Overlay mit Blur Effect</h4>
              <BOverlay :show="overlayShow3" rounded blur="10px" opacity="0.5">
                <BCard title="Blurred Card">
                  <BCardText>
                    Overlay mit Blur-Effekt (10px) und Transparenz (0.5).
                  </BCardText>
                  <BButton variant="info" @click="overlayShow3 = !overlayShow3">
                    Toggle Overlay
                  </BButton>
                </BCard>
              </BOverlay>
            </BCol>

            <BCol md="6" class="mb-4">
              <h4 class="h6 mb-2">Overlay mit Custom Content</h4>
              <BOverlay :show="overlayShow4" rounded variant="dark" opacity="0.85">
                <template #overlay>
                  <div class="text-center">
                    <BSpinner variant="light" class="mb-2" />
                    <p class="text-white mb-0">Daten werden geladen...</p>
                  </div>
                </template>
                <BCard title="Custom Overlay Content">
                  <BCardText>
                    Overlay mit benutzerdefiniertem Inhalt (Text + Spinner).
                  </BCardText>
                  <BButton variant="warning" @click="overlayShow4 = !overlayShow4">
                    Toggle Overlay
                  </BButton>
                </BCard>
              </BOverlay>
            </BCol>

            <BCol md="6" class="mb-4">
              <h4 class="h6 mb-2">Overlay ohne Spinner</h4>
              <BOverlay :show="overlayShow5" rounded :no-spinner="true" variant="danger" opacity="0.6">
                <BCard title="No Spinner">
                  <BCardText>
                    Overlay ohne Spinner, nur mit Farbe (danger) und Transparenz.
                  </BCardText>
                  <BButton variant="danger" @click="overlayShow5 = !overlayShow5">
                    Toggle Overlay
                  </BButton>
                </BCard>
              </BOverlay>
            </BCol>

            <BCol md="6" class="mb-4">
              <h4 class="h6 mb-2">Spinner Varianten</h4>
              <div class="d-flex flex-column gap-2">
                <BButton variant="outline-primary" size="sm" @click="overlayShow6 = !overlayShow6">
                  {{ overlayShow6 ? 'Hide' : 'Show' }} Primary Spinner
                </BButton>
                <BOverlay :show="overlayShow6" rounded spinner-variant="primary" spinner-small>
                  <BCard body-class="p-3">
                    <p class="mb-0">Kleiner Primary Spinner</p>
                  </BCard>
                </BOverlay>

                <BButton variant="outline-success" size="sm" @click="overlayShow7 = !overlayShow7" class="mt-2">
                  {{ overlayShow7 ? 'Hide' : 'Show' }} Success Spinner
                </BButton>
                <BOverlay :show="overlayShow7" rounded spinner-variant="success">
                  <BCard body-class="p-3">
                    <p class="mb-0">Success Spinner (normale Größe)</p>
                  </BCard>
                </BOverlay>
              </div>
            </BCol>
          </BRow>

          <h3 class="mb-3 mt-4">Overlay auf Formularen</h3>
          <BRow>
            <BCol md="12">
              <BOverlay :show="overlayShowForm" rounded blur="2px">
                <BCard title="Formular mit Overlay">
                  <BFormFloatingLabel label="Name" class="mb-3">
                    <BFormInput placeholder="Name eingeben" />
                  </BFormFloatingLabel>
                  <BFormFloatingLabel label="Email" class="mb-3">
                    <BFormInput type="email" placeholder="email@example.com" />
                  </BFormFloatingLabel>
                  <div class="d-flex gap-2">
                    <BButton variant="primary" @click="simulateFormSubmit">
                      Absenden (3s Overlay)
                    </BButton>
                    <BButton variant="secondary" @click="overlayShowForm = !overlayShowForm">
                      Toggle Overlay
                    </BButton>
                  </div>
                </BCard>
              </BOverlay>
            </BCol>
          </BRow>
        </section>

        <!-- Spinners Section -->
        <section class="mb-5">
          <h2 class="mb-3">Spinners</h2>
          <div class="d-flex flex-wrap gap-3 align-items-center">
            <BSpinner variant="primary" />
            <BSpinner variant="secondary" />
            <BSpinner variant="success" />
            <BSpinner variant="danger" />
            <BSpinner variant="warning" />
            <BSpinner variant="info" />
            <BSpinner type="grow" variant="primary" />
            <BSpinner type="grow" variant="success" />
          </div>
        </section>

        <!-- Progress Bars Section -->
        <section class="mb-5">
          <h2 class="mb-3">Progress Bars</h2>
          <BProgress :value="25" variant="primary" class="mb-2" />
          <BProgress :value="50" variant="success" class="mb-2" />
          <BProgress :value="75" variant="warning" class="mb-2" />
          <BProgress :value="100" variant="danger" class="mb-2" />
          <BProgress :value="60" variant="info" striped class="mb-2" />
          <BProgress :value="80" variant="success" striped animated class="mb-2" />
        </section>

        <!-- Tables Section -->
        <section class="mb-5">
          <h2 class="mb-3">Tables</h2>
          <BTable :items="tableItems" :fields="tableFields" striped hover />
        </section>

        <!-- Pagination Section -->
        <section class="mb-5">
          <h2 class="mb-3">Pagination</h2>
          <BPagination v-model="currentPage" :total-rows="100" :per-page="10" />
        </section>

        <!-- Dropdowns Section -->
        <section class="mb-5">
          <h2 class="mb-3">Dropdowns</h2>
          <div class="d-flex flex-wrap gap-2">
            <BDropdown text="Primary Dropdown" variant="primary">
              <BDropdownItem>Action 1</BDropdownItem>
              <BDropdownItem>Action 2</BDropdownItem>
              <BDropdownDivider />
              <BDropdownItem>Separated Action</BDropdownItem>
            </BDropdown>

            <BDropdown text="Secondary Dropdown" variant="secondary">
              <BDropdownItem>Action 1</BDropdownItem>
              <BDropdownItem>Action 2</BDropdownItem>
            </BDropdown>

            <BDropdown text="Success Dropdown" variant="success">
              <BDropdownItem>Action 1</BDropdownItem>
              <BDropdownItem>Action 2</BDropdownItem>
            </BDropdown>
          </div>
        </section>

        <!-- Toast Triggers Section -->
        <section class="mb-5">
          <h2 class="mb-3">Toast Notifications</h2>
          <div class="d-flex flex-wrap gap-2">
            <BButton variant="primary" @click="showToast('primary')">Primary Toast</BButton>
            <BButton variant="success" @click="showToast('success')">Success Toast</BButton>
            <BButton variant="danger" @click="showToast('danger')">Danger Toast</BButton>
            <BButton variant="warning" @click="showToast('warning')">Warning Toast</BButton>
          </div>
        </section>

        <!-- Modals Section -->
        <section class="mb-5">
          <h2 class="mb-3">Modals</h2>
          <BButton variant="primary" @click="showModal = true">Open Modal</BButton>

          <BModal v-model="showModal" title="Test Modal" ok-title="Speichern" cancel-title="Abbrechen">
            <p>Dies ist der Inhalt des Modals.</p>
            <BFormFloatingLabel label="Test Input">
              <BFormInput placeholder="Geben Sie Text ein" />
            </BFormFloatingLabel>
          </BModal>
        </section>

        <!-- List Groups Section -->
        <section class="mb-5">
          <h2 class="mb-3">List Groups</h2>
          <BRow>
            <BCol md="6">
              <BListGroup>
                <BListGroupItem>Standard Item</BListGroupItem>
                <BListGroupItem active>Active Item</BListGroupItem>
                <BListGroupItem disabled>Disabled Item</BListGroupItem>
                <BListGroupItem variant="primary">Primary Item</BListGroupItem>
                <BListGroupItem variant="success">Success Item</BListGroupItem>
                <BListGroupItem variant="danger">Danger Item</BListGroupItem>
              </BListGroup>
            </BCol>
          </BRow>
        </section>
      </div>


    </template>
  </PageLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import PageLayout from '@/componentsv3/PageLayout.vue';
import PageHeader from '@/componentsv3/PageHeader.vue';
import PageSidebar from '@/componentsv3/PageSidebar.vue';
import CustomCard from '@/componentsv3/CustomCard.vue';
import { ChevronRight, Download, Info, Save, Share2, Check, X, AlertTriangle, Sun, Moon, ExternalLink } from 'lucide-vue-next';
import { useToast } from 'bootstrap-vue-next';

export default {
  name: 'Playground',

  components: {
    ChevronRight, Download, Info, Save, Share2, Check, X, AlertTriangle, Sun, Moon, ExternalLink,
    CustomCard,
    PageLayout,
    PageHeader,
    PageSidebar
  },

  setup() {
    const { show } = useToast();
    return { showToast: show };
  },

  data() {
    return {
      testForm: {
        text: '',
        email: '',
        password: '',
        select: null,
        textarea: '',
        number: null,
        date: null,
        checkbox1: false,
        checkbox2: false,
        radio: 'option1',
        switch: false
      },
      selectOptions: [
        { value: null, text: 'Bitte auswählen' },
        { value: 'option1', text: 'Option 1' },
        { value: 'option2', text: 'Option 2' },
        { value: 'option3', text: 'Option 3' }
      ],
      tableItems: [
        { id: 1, name: 'Item 1', status: 'Aktiv', value: 100 },
        { id: 2, name: 'Item 2', status: 'Inaktiv', value: 200 },
        { id: 3, name: 'Item 3', status: 'Aktiv', value: 300 }
      ],
      tableFields: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name' },
        { key: 'status', label: 'Status' },
        { key: 'value', label: 'Wert' }
      ],
      currentPage: 1,
      showModal: false,
      kpis: ['KPI 1', 'KPI 2', 'KPI 3', ' as'],
      clientId: null,

       // Overlay states
      overlayShow1: false,
      overlayShow2: false,
      overlayShow3: false,
      overlayShow4: false,
      overlayShow5: false,
      overlayShow6: false,
      overlayShow7: false,
      overlayShowForm: false,


      // Treeselect states
      treeselectSingle: null,
      treeselectSingleOpen: null,
      treeselectMulti: [],
      treeselectMultiOpen: [],
      treeselectFlat: null,
      treeselectDisabled: 'option-1-1',

      // Treeselect hierarchische Optionen
      treeselectOptions: [
        {
          id: 'option-1',
          label: 'Deutschland',
          children: [
            { id: 'option-1-1', label: 'Bayern' },
            { id: 'option-1-2', label: 'Berlin' },
            { id: 'option-1-3', label: 'Hamburg' }
          ]
        },
        {
          id: 'option-2',
          label: 'Österreich',
          children: [
            { id: 'option-2-1', label: 'Wien' },
            { id: 'option-2-2', label: 'Salzburg' }
          ]
        },
        {
          id: 'option-3',
          label: 'Schweiz',
          children: [
            { id: 'option-3-1', label: 'Zürich' },
            { id: 'option-3-2', label: 'Genf' }
          ]
        }
      ],

      // Treeselect flache Optionen
      treeselectFlatOptions: [
        { id: 'flat-1', label: 'Option 1' },
        { id: 'flat-2', label: 'Option 2' },
        { id: 'flat-3', label: 'Option 3' },
        { id: 'flat-4', label: 'Option 4' }
      ]
    }
  },

  mounted() {
  },

  computed: {
    ...mapGetters('auth', ['userDisplayName'])
  },

  methods: {
    showToast(variant) {
      this.showToast({
        title: 'Toast',
        body: `Dies ist eine ${variant} Toast-Benachrichtigung`,
        props: {
          variant: variant,
          autoHide: true,
          delay: 3000,
          noCloseButton: false,
        }
      });
    },

    simulateFormSubmit() {
      this.overlayShowForm = true;
      setTimeout(() => {
        this.overlayShowForm = false;
      }, 3000);
    }
  }
};
</script>

<style lang="scss" scoped>

section {
  background: var(--bs-body-bg);
  padding: 2rem;
  border-radius: var(--bs-border-radius);
  border: 1px solid var(--bs-border-color);
}

h1 {
  color: var(--bs-body-color);
}

h2 {
  color: var(--bs-primary);
  font-size: 1.5rem;
  border-bottom: 2px solid var(--bs-border-color);
  padding-bottom: 0.5rem;
}

h3 {
  color: var(--bs-secondary);
  font-size: 1.25rem;
}
</style>
